import React, {useState, useEffect} from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import axios from 'axios';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {useSessionStore} from '../../hooks/useSessionStore';
import {Document, Page} from 'react-pdf';
import {useNavigate} from 'react-router-dom';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

export const DocumentosMiEmpresa = (props) => {
	const {
		ListaArchivos,
		ordenarPorNombre,
		ordenarPorFecha,
		EstadoComparadorFecha,
		EstadoComparadorNombre,
		empresa,
		FiltroNombre,
		setFiltroNombre,
		FiltroFecha,
	} = props;

	const TiposDocumentos = {
		sociedad: [
			{nombre: 'CIF', url: 'documentosSociedadesCIF', nombreDoc: 'CIF-'},
			{
				nombre: 'Registro IAE',
				url: 'documentosSociedadesRegistroIAE',
				nombreDoc: 'Registro_IAE-',
			},
			{
				nombre: 'Seguro de responsavilidad civil',
				url: 'documentosSeguroRC',
				nombreDoc: 'Seguro_Responsabilidad_Civil-',
			},
		],
		autonomo: [
			{
				nombre: 'Alta registro autonomos',
				url: 'documentosAutonomosRegistroAutonomos',
				nombreDoc: 'Registro_Autonomos-',
			},
			{
				nombre: 'Alta seguridad social',
				url: 'documentosAutonomosAltaSS',
				nombreDoc: 'Alta_Seguridad_Social-',
			},
			{
				nombre: 'Titulación acreditante',
				url: 'documentosAutonomosTitulacion',
				nombreDoc: 'Titulacion_Acreditante-',
			},
			{
				nombre: 'Seguro de responsavilidad civil',
				url: 'documentosSeguroRC',
				nombreDoc: 'Seguro_Responsabilidad_Civil-',
			},
		],
	};
	const [TipoDocumentoNuevo, setTipoDocumentoNuevo] = useState();
	/* A hook that allows you to navigate between routes. */
	const navigate = useNavigate();

	/* Using the useSessionStore hook to set the state of the UsuarioContext. */
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
	const [File, setFile] = useState(null);
	const [ErrorTypeFile, setErrorTypeFile] = useState(false);
	const [ModalAnadirDucumento, setModalAnadirDucumento] = useState(false);

	const handleSubmit = (e) => {
		e.preventDefault();
		if (File.type.toString() == 'application/pdf') {
			const formData = new FormData();
			//formData.append("documento", File);
			formData.append('documento', File);
			formData.append(
				'nombre',
				TipoDocumentoNuevo.nombreDoc + Usuario.prestadorServicios.nombreEmpresa
			);
			//formData.append("nombre", "Prueba");
			formData.append('usuario_id', Usuario.prestadorServicios.usuario.id);
			axios
				.post(window.ipdirection + TipoDocumentoNuevo.url + '/', formData, {
					headers: {
						Authorization: 'Bearer ' + Usuario.access,
					},
				})
				.then((response) => {
					console.log(response);
				})
				.catch((error) => {
					console.log(error.response.data);
				});
		} else {
			setErrorTypeFile(true);
		}
	};

	const getDoc = (nombre) => {
		if (empresa.is_sociedad) {
			return TiposDocumentos.sociedad.find((documento) => documento.nombre === nombre);
		} else {
			return TiposDocumentos.autonomo.find((documento) => documento.nombre === nombre);
		}
	};

	const eliminarDocumento = async (doc) => {
		await axios({
			method: 'delete',
			url: window.ipdirection + doc.url + '/' + doc.id + '/',
			headers: {
				Authorization: 'Bearer ' + Usuario.access,
			}
		}).then((response) => {;
			window.location.reload();
		}).catch((error) => {
			console.log(error);
		});
	}

	return (
		<>
			<div className='Documentos'>
				<div className='ListaDocumentos'>
					<div className='head-documentos'>
						<div className='centradorRight'>
							<div
								className='buttonAnadir'
								onClick={() => setModalAnadirDucumento(true)}
							>
								<div className='centrador'>
									<svg
										xmlns='http://www.w3.org/2000/svg'
										width='16'
										height='16'
										fill='currentColor'
										class='bi bi-plus-circle-fill'
										viewBox='0 0 16 16'
									>
										<path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z' />
									</svg>
								</div>
								<div>
									<b>Añadir Documento</b>
								</div>
							</div>
						</div>
					</div>
					<div>
						<div className='head-lista-documentos'>
							<div
								className='head-lista-documentos-documento'
								onClick={() => ordenarPorNombre()}
							>
								<div>Documento</div>
								<div>
									{EstadoComparadorNombre === true ? (
										<svg
											xmlns='http://www.w3.org/2000/svg'
											width='20'
											height='20'
											fill='currentColor'
											class='bi bi-caret-down-fill'
											viewBox='0 0 16 16'
										>
											<path d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z' />
										</svg>
									) : (
										<svg
											xmlns='http://www.w3.org/2000/svg'
											width='20'
											height='20'
											fill='currentColor'
											class='bi bi-caret-up-fill'
											viewBox='0 0 16 16'
										>
											<path d='m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z' />
										</svg>
									)}
								</div>
							</div>
							<div
								className='head-lista-documentos-fecha'
								onClick={() => {
									ordenarPorFecha();
								}}
							>
								<div>Fecha</div>
								<div>
									{EstadoComparadorFecha ? (
										<svg
											xmlns='http://www.w3.org/2000/svg'
											width='20'
											height='20'
											fill='currentColor'
											class='bi bi-caret-down-fill'
											viewBox='0 0 16 16'
										>
											<path d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z' />
										</svg>
									) : (
										<svg
											xmlns='http://www.w3.org/2000/svg'
											width='20'
											height='20'
											fill='currentColor'
											class='bi bi-caret-up-fill'
											viewBox='0 0 16 16'
										>
											<path d='m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z' />
										</svg>
									)}
								</div>
							</div>
						</div>
						{ListaArchivos.map(
							(doc) =>
								doc.nombre.toLowerCase().includes(FiltroNombre.toLowerCase()) &&
								FiltroFecha !== undefined &&
								FiltroFecha.toISOString().substr(0, 10) <= doc.fecha && (
									<>
										<div className='separador' />
										<div className='documento-mi-empresa'>
											<div className='centrador'>
												<div className='logo-pdf-documuento-mi-empresa centrador'>
													<svg
														xmlns='http://www.w3.org/2000/svg'
														width='24'
														height='24'
														fill='currentColor'
														class='bi bi-filetype-pdf'
														viewBox='0 0 16 16'
													>
														<path
															fill-rule='evenodd'
															d='M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z'
														/>
													</svg>
												</div>
											</div>
											<div className='nombre-documento-mi-empresa '>
												<div className='centradorLeft'>
													<a
														href={doc.archivo}
														target='_blank'
													>
														{doc.nombre}
													</a>
												</div>
												<div className='centradorLeft'>
													<p>{doc.fecha}</p>
												</div>
											</div>
											<div className='logo-trash-documuento-mi-empresa centrador'
												onClick={() => {eliminarDocumento(doc)}}
											>
												<svg
													xmlns='http://www.w3.org/2000/svg'
													width='20'
													height='20'
													fill='currentColor'
													class='bi bi-trash3'
													viewBox='0 0 16 16'
												>
													<path d='M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5ZM11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H2.506a.58.58 0 0 0-.01 0H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1h-.995a.59.59 0 0 0-.01 0H11Zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5h9.916Zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47ZM8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z' />
												</svg>
											</div>
										</div>
									</>
								)
						)}
					</div>
				</div>
			</div>
			<Modal
				centered={true}
				isOpen={ModalAnadirDucumento}
			>
				<ModalHeader>Subir documento a la plataforma</ModalHeader>
				<ModalBody>
					<div className='modal-añadir-documento'>
						<div>
							<div>
								Selecione el tipo de documento que desea subir a la plataforma
							</div>
							{empresa.is_sociedad ? (
								<Select
									className='inputTextUsuario inputDrop-anadir-documento'
									placeholder='------'
									onChange={(event) =>
										setTipoDocumentoNuevo(getDoc(event.target.value))
									}
								>
									{TiposDocumentos.sociedad.map((doc, index) => (
										<MenuItem
											value={doc.nombre}
											key={index}
										>
											{doc.nombre}
										</MenuItem>
									))}
								</Select>
							) : (
								<Select
									className='inputTextUsuario inputDrop-anadir-documento'
									placeholder='------'
									onChange={(event) =>
										setTipoDocumentoNuevo(getDoc(event.target.value))
									}
								>
									{TiposDocumentos.autonomo.map((doc, index) => (
										<MenuItem
											value={doc.nombre}
											key={index}
										>
											{doc.nombre}
										</MenuItem>
									))}
								</Select>
							)}
						</div>
						{TipoDocumentoNuevo && (
							<div className='centradorLeft'>
								<div>Selecione el archivo</div>
								<input
									type='file'
									onChange={(e) => setFile(e.target.files[0])}
									accept='application/pdf'
									className='inputTextUsuario'
								/>
							</div>
						)}
					</div>
				</ModalBody>
				<ModalFooter>
					<div className='buttonsPerfilEmpresa '>
						<div
							className='button'
							onClick={() => {
								setTipoDocumentoNuevo();
								setModalAnadirDucumento(false);
							}}
						>
							<b>Cancelar</b>
						</div>
						<div
							className='buttonB'
							onClick={(e) => {
								handleSubmit(e);
								setTipoDocumentoNuevo();
								setModalAnadirDucumento(false);
							}}
						>
							<b>Enviar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
			<Modal
				centered={true}
				isOpen={ErrorTypeFile}
			>
				<ModalHeader>Ups...</ModalHeader>
				<ModalBody>El tipo de fichero debe ser .pdf</ModalBody>
				<ModalFooter>
					<div className='centrador'>
						<div
							className='button'
							onClick={() => setErrorTypeFile(false)}
						>
							<b>Aceptar</b>
						</div>
					</div>
				</ModalFooter>
			</Modal>
		</>
	);
};
